import { render, staticRenderFns } from "./BlockMainPageSurvey.vue?vue&type=template&id=7629126d&"
import script from "./BlockMainPageSurvey.vue?vue&type=script&lang=ts&"
export * from "./BlockMainPageSurvey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports